import React, { useEffect, useState } from "react";
import { AddIcon, LoadingIcon } from "../../assets/icons/Icons";
import FormSection from "../form/Section";
import FormHeader from "../form/Header";
import Switch from "../form/Switch";
import Popup from "../Popup";
import { CreateSellSpecialtyItem as AddSellSpecialtyItem } from "../../api/sell-specialty-items/createSellSpecialtyItem";
import { DollarsToCents } from "../../utils/formatPrice";
import useForm from "../../hooks/useForm";
import FormErrorsOutput from "../form/FormErrorsOutput";
import { useTranslation } from "react-i18next";

const CreateSellSpecialtyItem = ({ onCreate, onClose, ...props }) => {
  const { t } = useTranslation();

  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [taxable, setTaxable] = useState(true);
  const [isActive, setIsActive] = useState(true);

  const { loading, error, fieldErrors, handleSubmit } = useForm(onCreate);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmit(AddSellSpecialtyItem, {
      name,
      unit_price: DollarsToCents(price),
      taxable,
      is_active: isActive,
    });
  };

  useEffect(() => {
    const priceIsValid = price !== "" && Number(price) >= 0;
    setSubmitDisabled(!name || !priceIsValid);
  }, [name, price]);

  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <form method="post" onSubmit={handleFormSubmit}>
        <FormHeader
          title={t("Add Specialty Item")}
          description={t(
            "Specialty items are sold at a fixed price at every office in the company."
          )}
          className="mb-5"
        ></FormHeader>

        <div className="row mb-5">
          <div className="col-xs-12">
            <FormSection title={t("Item Name")} required>
              <input
                type="text"
                name="name"
                id="name"
                maxLength="255"
                placeholder={t("Item name")}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormSection>
          </div>
        </div>

        <div className="row mb-5">
          <div className="col-xs-6">
            <FormSection title={t("Price")} required>
              <input
                type="number"
                name="unit_price"
                id="unit_price"
                min="0"
                step="0.01"
                placeholder="0.00"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </FormSection>
          </div>
          <div className="col-xs-6">
            <FormSection title={t("Tax Treatment")} required>
              <select
                name="taxable"
                id="taxable"
                value={taxable ? "taxable" : "non_taxable"}
                onChange={(e) => setTaxable(e.target.value === "taxable")}
              >
                <option value="taxable">{t("Taxable")}</option>
                <option value="non_taxable">{t("Non-taxable")}</option>
              </select>
            </FormSection>
          </div>
        </div>

        <div className="row mb-5 align-items-center">
          <div className="col-xs-12">
            <Switch title={t("Active")}>
              <input
                type="checkbox"
                name="is_active"
                id="is_active"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
            </Switch>
            <p>
              {t(
                "Setting an item to Inactive removes it from the agent's dropdown. It stays on every sale already placed and in all reports."
              )}
            </p>
          </div>
        </div>

        <div className="text-right">
          <button
            className={`btn btn-primary btn-medium ${
              loading ? "btn-loading" : ""
            }`}
            type="submit"
            name="submit"
            disabled={submitDisabled}
          >
            {loading ? <LoadingIcon /> : <AddIcon />}
            {t("Add")}
          </button>
        </div>
        <FormErrorsOutput error={error} fieldErrors={fieldErrors} />
      </form>
    </Popup>
  );
};

export default CreateSellSpecialtyItem;
